// extracted by mini-css-extract-plugin
module.exports = {"icon":"Accordion_icon__2DpPe","icon--active":"Accordion_icon--active__X2Yof"};